import { render, staticRenderFns } from "./ProductCategoriesDashboard.vue?vue&type=template&id=05283d26&"
import script from "./ProductCategoriesDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports